import './App.css';
import Navbar from './components/Navbar';
import React, { useState } from 'react'
import Alert from "./components/Alert";
import copy from "copy-to-clipboard";

function App() {
  const [text, setText] = useState("");
  const [cpText, setCpText] = useState("Copy")
  let [orignalText, setOrignalText] = useState(text)

  const [alert, setAlert] = useState(null)
  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type
    })
  }

  function onChangeFunc(event) {
    if (text !== "") { setOrignalText(text) }
    setText(event.target.value)
  }
  function upperCase() {
    setText(text.toUpperCase())
  }
  function lowerCase() {
    setText(text.toLowerCase())
  }
  function copyToClipboard() {
    // navigator.clipboard.writeText(text)
    copy(text)
    setCpText("Copied")
    setTimeout(() => {
      setCpText("Copy")
      showAlert(null)
    }, 2700);
    showAlert("Copied to clipboard", "primary")
  }
  let removeSpace = () => {
    let xSpaceLess = text.replace(/\s+/g, ' ').trim();
    setText(xSpaceLess)
  }
  let orignal = () => {
    if (text !== "") {
      setText(orignalText)
    }
  }
  let clearText = () => {
    setText("")
  }
  let replaceWord = () => {
    document.getElementById("replace").style.display = "flex"
    document.getElementById("replace-btn").style.display = "none"
    let userWord = document.getElementById('word').value
    let changeWith = document.getElementById('changeWith').value

    let mila = text.includes(userWord)
    if (mila) {
      let currentTextValue = text
      let replaced = currentTextValue.replace(userWord, changeWith)
      setText(replaced)
    }
  }

  return (
    <>
      <Navbar heading="TextUtils" />
      <div className="container">
        <div className="form-group">
          <center>
            <h2 className='my-5'>Welcome to Textutils</h2>
          </center>
          <textarea onChange={onChangeFunc} value={text} className="form-control" id="exampleFormControlTextarea1" rows="10" placeholder='Type here...'>{text}</textarea>
          <br />
          <div className="btn-container">
            <div>
              <button className="btn btn-primary" onClick={upperCase}>UpperCase</button>
              <button className="btn btn-primary" onClick={lowerCase}>LowerCase</button>
              <button type="button" className="btn btn-primary" onClick={removeSpace}>Remove Extra Spaces</button>
              <button type="button" className="btn btn-primary" id="replace-btn" onClick={replaceWord}>Replace</button>
              <button type="button" className="btn btn-primary" onClick={orignal}>Orignal</button>
              <button className="btn btn-outline-primary" onClick={copyToClipboard}>{cpText}</button>
              <button type="button" className="btn btn-outline-primary" onClick={clearText}>Clear</button>
              {/* </div> */}
              <div className="replaceWindow" id='replace'>
                <input className="form-control" id='word' type="text" placeholder='Enter the word' />
                <input className="form-control" id='changeWith' type="text" placeholder='Replace with' />
                <button className="btn0 btn btn-primary" onClick={replaceWord}>Replace</button>
              </div>
              <Alert alert={alert} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
